var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"value":_vm.value,"size":_vm.size},on:{"input":_vm.handleInput}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.domain_id}},[_vm._v(_vm._s(option.domain_name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }